<template>
  <div :class="[{active: !isOpen},'faqline']">
    <div class="question" @click="open()">
      <p>{{question}}</p>
      <span class="btn_ac"></span>
    </div>
    <transition name="slide-fade">
      <div class="answer" v-if="!isOpen">
        <p v-html="answer"></p>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: "faqLine",
  props: {
    question: {
      type: String,
      default: "",
    },
    answer: {
      type: String,
      default: "",
    }
  },
  data() {
    return {
      isOpen: true
    }
  },
  methods: {
    open() {
      this.isOpen = !this.isOpen;
    }
  }
}
</script>

<style scoped lang="scss">
.faqline {
  margin-top: -1px;
  &.active {
    .question {
      position: relative;
      .btn_ac{
        &::before {
        -webkit-transform: rotate(90deg) translate(-50%, -50%);
        transform: rotate(90deg) translate(-50%, -50%);
        transform-origin: 0 0;
        }
        &::after {
          opacity: 0;
        }
      }
    }
  }
  p {
    font-weight: 500;
    font-size: 15px;
    @media print, screen and (max-width: 1160px) {
      font-size: 11px;
    }
  }
  &:last-child{
    .answer{
      border-bottom: 1px solid #533488;
    }
  }
  .question,.answer {
    display: flex;
    box-sizing: border-box;
    p {
      margin: 0;
    }
  }
  .question {
    padding: 2em 5.8%;
    position: relative;
    align-items: center;
    border-top: 1px solid #533488;
    border-bottom: 1px solid #533488;
    @media print, screen and (max-width: 1160px) {
      padding: 1.3em 6%;
    }
  }
  p{
    display: inline-block;
    flex: 1;
  }
  .btn_ac {
    position: relative;
    width: 2.5em;
    height: 2.5em;
    margin-left: 1.2em;
    border-radius: 50vh;
    border: 1px solid #533488;
    cursor: pointer;
      @media print, screen and (max-width: 1160px) {
        width: 1.6em;
        height: 1.6em;
      }
    &::before,
    &::after {
      content: "";
      background-color: #533488;
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      transition: background-color 0.3s;
    }
    &::before {
      width: 1px;
      height: 55%;
      transition: transform 0.3s;
      -webkit-transform: rotate(0deg) translate(-50%, -50%);
      transform: rotate(0deg) translate(-50%, -50%);
      transform-origin: top center;
    }
    &::after {
      width: 55%;
      height: 1px;
      transition: opacity 0.3s;
    }
  }
  .answer {
    padding: 2em calc(5.8% + 2.5em) 2em 5.8%;
    display: flex;
    justify-content: space-between;
    @media print, screen and (max-width: 1160px) {
      padding: 1.3em 6%;
      align-items: center;
    }
    &::before{
      content:"";
      display: inline-block;
      // width:33px;
      // height: 33px;
      margin-right: 8%;
      margin-right: 50px;
      font-family: 'ots-mincho', serif;
      font-size: 30px;
      content:"A";
      margin-top: 0.25em;
      @media print, screen and (max-width: 1160px) {
        margin-right: min(20px, 6%);
        margin-top: 0;
        font-size: 23px;
      }
    }
  }
}
.slide-fade-enter-active {
  transition: all .3s ease-out;
}
.slide-fade-leave-active {
  transition: all .3s ease-out;
}
.slide-fade-enter, .slide-fade-leave-to
/* .slide-fade-leave-active below version 2.1.8 */ {
  transform: translateY(-5px);
  opacity: 0;
}
</style>
